// Base class for all keen sliders - only declare if it doesn't exist
if (typeof BaseKeenSlider === 'undefined') {
  class BaseKeenSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector(".keen-slider");
      
      // Debug logging for base class
      // if (this.tagName.toLowerCase() === 'timeline-cards-slider') {
      //   console.log('BaseKeenSlider - Raw dataset:', this.dataset);
      //   console.log('BaseKeenSlider - All data attributes:', {
      //     'data-slides-per-view-mobile': this.getAttribute('data-slides-per-view-mobile'),
      //     'data-carousel-centered-mobile': this.getAttribute('data-carousel-centered-mobile'),
      //     'data-carousel-spacing-mobile': this.getAttribute('data-carousel-spacing-mobile'),
      //     'data-carousel-loop': this.getAttribute('data-carousel-loop')
      //   });
      // }
      
      // Get all data attributes with fallbacks
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop || "3";
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet || "2";
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile || "1";
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop || "20";
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet || "15";
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile || "10";
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop || "false";
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet || "false";
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile || "false";
      this.carouselMode = this.dataset.carouselMode || "free-snap";
      this.carouselLoop = this.dataset.carouselLoop || "false";
      this.carouselAutoplay = this.dataset.carouselAutoplay || false;
      
      // Debug logging for base class after processing
      // if (this.tagName.toLowerCase() === 'timeline-cards-slider') {
      //   console.log('BaseKeenSlider - Processed values:', {
      //     slidesPerViewMobile: this.slidesPerViewMobile,
      //     carouselCenteredMobile: this.carouselCenteredMobile,
      //     carouselSpacingMobile: this.carouselSpacingMobile,
      //     carouselLoop: this.carouselLoop
      //   });
      // }
      
      setTimeout(() => {
        // The timeout is for the customizer
        this.initSlider();
      }, 1);
    }

    initSlider() {
      var config = {
        mode: this.carouselMode,
        loop: this.carouselLoop === "true",
        prevButton: this.querySelector(".keen-arrow.prev"),
        nextButton: this.querySelector(".keen-arrow.next"),
        autoplay: this.carouselAutoplay,
        breakpoints: {
          "(min-width: 901px)": {
            centered: this.carouselCenteredDesktop === "true",
            spacing: parseInt(this.carouselSpacingDesktop),
            slidesPerView: parseInt(this.slidesPerViewDesktop),
          },
          "(min-width: 601px) and (max-width: 900px)": {
            centered: this.carouselCenteredTablet === "true",
            spacing: parseInt(this.carouselSpacingTablet),
            slidesPerView: parseInt(this.slidesPerViewTablet),
          },
          "(max-width: 600px)": {
            centered: this.carouselCenteredMobile === "true",
            spacing: parseInt(this.carouselSpacingMobile),
            slidesPerView: parseFloat(this.slidesPerViewMobile), // Use parseFloat for decimal values
          },
        },
      };
      
      var dots = this.querySelector(".keen-dots");
      if (dots) {
        config = { ...config, dots: dots };
      }
      
      this.sliderObj = new KeenSlider(this.sliderElement, config);
    }
  }
  
  // Make BaseKeenSlider globally available
  window.BaseKeenSlider = BaseKeenSlider;
}

// Info Cards Slider - extends base class
if (!customElements.get("info-cards-slider")) {
  class ComponentInfoCardsSlider extends BaseKeenSlider {
    constructor() {
      super();
      this._expandableBound = false;
      this._onExpandableClick = this._onExpandableClick.bind(this);
    }

    connectedCallback() {
      if (this._expandableBound) return;
      this._expandableBound = true;
      // Use event delegation to avoid multiple listeners and global observers
      this.addEventListener('click', this._onExpandableClick, true);
    }

    disconnectedCallback() {
      if (!this._expandableBound) return;
      this.removeEventListener('click', this._onExpandableClick, true);
      this._expandableBound = false;
    }

    _onExpandableClick(e) {
      const icon = e.target.closest('svg[data-icon="plus-3"], .icon-plus-3, svg[data-icon="minus-2"], .icon-minus-2');
      if (!icon || !this.contains(icon)) return;

      const innerContent = icon.closest('.card-inner')?.querySelector('.inner-content');
      if (!innerContent) return;

      e.preventDefault();
      e.stopPropagation();

      if (icon.matches('svg[data-icon="minus-2"], .icon-minus-2')) {
        innerContent.classList.remove('active');
      } else {
        innerContent.classList.add('active');
      }
    }
  }
  customElements.define("info-cards-slider", ComponentInfoCardsSlider);
}

// Doctors Reviews Slider - extends base class
if (!customElements.get("doctors-reviews-slider")) {
  class ComponentDoctorsReviewsSlider extends BaseKeenSlider {
    constructor() {
      super();
      // Any doctors-reviews specific logic can go here
    }
  }
  customElements.define("doctors-reviews-slider", ComponentDoctorsReviewsSlider);
}

// Timeline Cards Slider for mobile - extends base class
if (!customElements.get("timeline-cards-slider")) {
  class ComponentTimelineCardsMobileSlider extends BaseKeenSlider {
    constructor() {
      super();
      
      // Debug logging to understand the issue
      // console.log('Timeline Slider - Dataset values:', {
      //   slidesPerViewMobile: this.dataset.slidesPerViewMobile,
      //   carouselCenteredMobile: this.dataset.carouselCenteredMobile,
      //   carouselSpacingMobile: this.dataset.carouselSpacingMobile,
      //   carouselLoop: this.dataset.carouselLoop
      // });
      
      // Timeline specific logic - respect the data attributes from the section
      // Only override desktop and tablet if not explicitly set
      if (!this.dataset.slidesPerViewDesktop) {
        this.slidesPerViewDesktop = "1"; // Force single view on desktop if not set
      }
      if (!this.dataset.slidesPerViewTablet) {
        this.slidesPerViewTablet = "1";  // Force single view on tablet if not set
      }
      if (!this.dataset.slidesPerViewMobile) {
        this.slidesPerViewMobile = "1";  // Force single view on mobile if not set
      }
      if (!this.dataset.carouselSpacingDesktop) {
        this.carouselSpacingDesktop = "0";
      }
      if (!this.dataset.carouselSpacingTablet) {
        this.carouselSpacingTablet = "0";
      }
      if (!this.dataset.carouselCenteredDesktop) {
        this.carouselCenteredDesktop = "false";
      }
      if (!this.dataset.carouselCenteredTablet) {
        this.carouselCenteredTablet = "false";
      }
      if (!this.dataset.carouselCenteredMobile) {
        this.carouselCenteredMobile = "false";
      }
      
      // Debug logging after processing
      // console.log('Timeline Slider - Processed values:', {
      //   slidesPerViewMobile: this.slidesPerViewMobile,
      //   carouselCenteredMobile: this.carouselCenteredMobile,
      //   carouselSpacingMobile: this.carouselSpacingMobile
      // });
    }

    initSlider() {
      var config = {
        mode: this.carouselMode,
        loop: this.carouselLoop === "true",
        prevButton: this.querySelector(".keen-arrow.prev"),
        nextButton: this.querySelector(".keen-arrow.next"),
        autoplay: this.carouselAutoplay,
        breakpoints: {
          "(min-width: 901px)": {
            centered: this.carouselCenteredDesktop === "true",
            spacing: parseInt(this.carouselSpacingDesktop),
            slidesPerView: parseInt(this.slidesPerViewDesktop),
          },
          "(min-width: 601px) and (max-width: 900px)": {
            centered: this.carouselCenteredTablet === "true",
            spacing: parseInt(this.carouselSpacingTablet),
            slidesPerView: parseInt(this.slidesPerViewTablet),
          },
          "(max-width: 600px)": {
            centered: this.carouselCenteredMobile === "true",
            spacing: parseInt(this.carouselSpacingMobile),
            slidesPerView: parseFloat(this.slidesPerViewMobile), // Use parseFloat for decimal values
          },
        },
      };
      
      // Debug logging for final config
      // console.log('Timeline Slider - Final config:', config);
      
      var dots = this.querySelector(".keen-dots");
      if (dots) {
        config = { ...config, dots: dots };
      }
      
      this.sliderObj = new KeenSlider(this.sliderElement, config);
    }
  }
  customElements.define("timeline-cards-slider", ComponentTimelineCardsMobileSlider);
}

